// PortfolioImage.js

import React from "react";
import "./PortfolioImage.css";
import image from "./image2.jpg";

const PortfolioImage = ({ imageUrl, title, description }) => {
  console.log(imageUrl);
  return (
    <div className="portfolio-image-container">
      <img src={image} alt={title} className="portfolio-image" />
      <div className="portfolio-text">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default PortfolioImage;
